import { List } from 'immutable';
import {
    ChannelKey,
    ExtensionKey,
    ProfileKey,
    QueueKey,
    ReferEntryKey,
} from './EntityKeys';
import { TelephoneNumber } from './TelephoneNumber';
import { TypedMap } from './TypedMap';

export interface Profiles {
    smsSenderNameOptions: TypedMap<
        Record<string, TypedMap<SmsSenderNameOption>>
    >;
    referal_sounds: List<TypedMap<ReferralSound>>;
    main_numbers: List<TypedMap<MainNumber>>;
    [extensionKey: ExtensionKey]: List<TypedMap<Profile>>;
}

export interface Profile {
    recordCalls: boolean;
    autoTranscribe: boolean;
    personalRecordCalls: boolean;
    personalAutoTranscribe: boolean;
    priority: number;
    channelLoginList: List<TypedMap<ChannelLoginList>>;
    editable: boolean;
    callerId: TypedMap<CallerId>;
    active: boolean;
    defaultProfile: boolean;
    available: boolean;
    spokenNotification: TypedMap<SpokenNotification>;
    parallelCalls: TypedMap<ParallelCalls>;
    callMVoip: boolean;
    pauseDuration?: number;
    pauseProfile: boolean;
    smsSenderNameId: TypedMap<SmsSenderNameId>;
    plusId: number;
    defaultDuration: string;
    queueLoginList: List<TypedMap<QueueLoginList>>;
    canBeCoMonitored: boolean;
    callForwarding: TypedMap<CallForwarding>;
    description: string;
    key: ProfileKey;
    operatorNote?: string;
    activeUntil?: string;
    explicitSelection?: boolean;
}
export interface ActiveProfile {
    active: boolean;
    activeUntil?: string;
    available: boolean;
    description: string;
    key: ProfileKey;
    lyncOnThePhone: boolean;
    operatorNote?: string;
    plusId?: number;
}
export interface NextScheduledProfile {
    available: boolean;
    description: string;
    extensionEntityKey: ExtensionKey;
    queueLoginList: List<TypedMap<QueueLoginList>>;
}

export interface ChannelLoginList {
    channelEntityKey: ChannelKey;
    loggedIn: boolean;
    key?: string;
}

export interface CallerId {
    fixedCallerIdType: string;
    fixedMainNumber?: TypedMap<FixedMainNumber>;
    canShowMobileCallerIdFromFixed: boolean;
    callerIdOptions: List<string>;
    hasLandlineCapableEndpoint?: boolean;
    groupId: string;
}

export interface FixedMainNumber {
    phoneNumber: string;
    number: TypedMap<TelephoneNumber>;
    description: string;
    key: string;
}

export interface SpokenNotification {
    referEntry: TypedMap<ReferEntry>;
    referPhraseType: string;
    referActionType: string;
    announceReferUntilTime: boolean;
    groupId: string;
}

interface ReferEntry {
    sound: TypedMap<Sound>;
    description: string;
    key: ReferEntryKey;
}

export interface ParallelCalls {
    parallelCallType: string;
    incomingCallOptions: List<string>;
    mexDelay: number;
    delayType: string;
    delayTypeOptions: List<string>;
    groupId: string;
    letThroughMexCalls: boolean;
}

export interface SmsSenderNameId {
    description: string;
    key: string;
}

export interface QueueLoginList {
    queueEntityKey: QueueKey;
    queueDescription?: string;
    queueNumber?: TypedMap<TelephoneNumber>;
    loggedIn: boolean;
    key?: string;
}

export interface CallForwarding {
    errorRedirect?: TypedMap<TelephoneNumber>;
    delayedRedirectNumber: TypedMap<DelayedRedirectNumber>;
    unconditionalRedirect: TypedMap<UnconditionalRedirect>;
    secondsOfDelay: number;
    errorRedirectNumber: TypedMap<ErrorRedirectNumber>;
    busyRedirect: TypedMap<TelephoneNumber>;
    groupId: string;
    busyRedirectNumber: TypedMap<BusyRedirectNumber>;
    delayedRedirect: TypedMap<TelephoneNumber>;
    redirect?: TypedMap<TelephoneNumber>;
}

export interface DelayedRedirectNumber {
    forwardingNumber: TypedMap<TelephoneNumber>;
    type: string;
}

export interface UnconditionalRedirect {
    type: string;
    forwardingNumber?: TypedMap<TelephoneNumber>;
}

export interface ErrorRedirectNumber {
    forwardingNumber?: TypedMap<TelephoneNumber>;
    type: string;
}

export interface BusyRedirectNumber {
    forwardingNumber: TypedMap<TelephoneNumber>;
    type: string;
}

export interface SmsSenderNameOption {
    description: string;
    key: string;
}

export interface ReferralSound {
    description: string;
    key: string;
    sound: TypedMap<Sound>;
}

interface Sound {
    name: string;
    description: string;
    playbackURL: string;
    recordingPIN: string;
    privateSound: boolean;
    key: string;
}

export interface MainNumber {
    description: string;
    key: string;
}

export interface ProfileDTO {
    description: string;
}

export const PlusID = {
    AVAILABLE: 0,
    LUNCH: 1,
    MEETING: 2,
    LEFT_FOR_THE_DAY: 3,
};
